import { local, useLocal } from "../util/index.ts";

import type { JSX } from "react";

const getWeightString = (pounds: number, units: "metric" | "us") => {
	if (typeof pounds !== "number") {
		return null;
	}

	if (units === "metric") {
		return `${Math.round(pounds / 2.205)} kg`;
	}

	return `${pounds} lbs`;
};

const Weight = ({ pounds }: { pounds: number }) => {
	const units = useLocal((state2) => state2.units);

	return getWeightString(pounds, units) as unknown as JSX.Element;
};

export default Weight;

export const wrappedWeight = (pounds: number) => {
	const units = local.getState().units;
	const string = getWeightString(pounds, units);

	return {
		value: string,
		sortValue: pounds,
	};
};
